import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import SliderHomeBanner from '../../component/slidercomponent/SliderHomeBanner';


import 'swiper/css';



import { Autoplay } from 'swiper/modules';

export default function HomeBanner() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}


                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                        <img src="assets/school/banner_14.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_15.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_16.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_17.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_10.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_11.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_12.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_13.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                        <img src="assets/school/banner_9.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                    
                        <img src="assets/school/banner_7.webp" alt="education" className="img-fluid asa " />
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_8.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_1.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_2.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_3.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_4.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_5.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/school/banner_6.webp" alt="education" className="img-fluid asa " />

                    </div>
                </SwiperSlide>


            </Swiper>
            {/* <SliderHomeBanner /> */}
        </>
    );
}
